<template>
  <div class="app-container">
    <BjRouteTabs :route-list="LOGISTICS_COMPANY_ROUTE_LIST" />
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial"
      @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessLogisticsCompanyPostCode.country')" prop="country">
            <BjSelectLov v-model="queryParams.country" :placeholder="$t('BusinessLogisticsCompanyPostCode.country')" :option-list="COUNTRY_LIST" />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessLogisticsCompanyPostCode.state')" prop="state">
            <BjInput v-model="queryParams.state" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessLogisticsCompanyPostCode.state')"
              clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessLogisticsCompanyPostCode.suburb')" prop="suburb">
            <BjInput v-model="queryParams.suburb" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessLogisticsCompanyPostCode.suburb')"
              clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessLogisticsCompanyPostCode.postcode')" prop="postcode">
            <BjInput v-model="queryParams.postcode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('BusinessLogisticsCompanyPostCode.postcode')"
              clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </template>

      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{
            $t('businessLogisticsCompany.common.add')
          }}
          </el-button>
          <el-button type="primary" @click="onImport">{{ $t('EXCELImportText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center"
            class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="scope">
              <el-button type="text" class="edit-btn"
                @click="onEdit(scope.row)">{{ $t('editText') }}
              </el-button>

              <el-button :disabled="scope.row.status == 1"
                type="text" class="delete-btn" @click="onDelete(scope.row)">{{
                  $t('delText') }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
    <!-- EXCEL导入 -->
    <ExcelImportDialog ref="ExcelImport" :country-list="COUNTRY_LIST" @submit="handleQuery" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { thirdApi, commonApi } from '@/api';
import { LOGISTICS_COMPANY_ROUTE_LIST } from '@/utils/constants';
import DataForm from './components/DataForm.vue';
import ExcelImportDialog from './components/ExcelImportDialog.vue';

export default {
  name: 'BusinessLogisticsCompanyPostCodeIndex',
  components: {
    DataForm,
    ExcelImportDialog
  },
  mixins: [pageMiXin],
  data() {
    return {
      LOGISTICS_COMPANY_ROUTE_LIST,
      queryApi: thirdApi.getPostCodePageList,
      // 查询参数
      queryParams: {
        country: 'AU',
        state: null,
        suburb: null,
        postcode: null,
        limit: 20,
        _postCodePage: true
      },
      labelList: [
        { label: this.$t('BusinessLogisticsCompanyPostCode.country'), prop: 'country', isCheck: true, disabled: false },
        { label: this.$t('BusinessLogisticsCompanyPostCode.state'), prop: 'state', isCheck: true, disabled: false },
        { label: this.$t('BusinessLogisticsCompanyPostCode.suburb'), prop: 'suburb', isCheck: true, disabled: false },
        { label: this.$t('BusinessLogisticsCompanyPostCode.postcode'), prop: 'postcode', isCheck: true, disabled: false },
        { label: this.$t('BusinessLogisticsCompanyPostCode.label'), prop: 'label', isCheck: true, disabled: false },
        { label: this.$t('BusinessLogisticsCompanyPostCode.labelSub'), prop: 'labelsub', isCheck: true, disabled: false },
        { label: this.$t('BusinessLogisticsCompanyPostCode.zone'), prop: 'zone', isCheck: true, disabled: false },
        { label: this.$t('businessLogisticsCompany.table.action'), prop: 'bjTableAction', isCheck: true, disabled: true },
      ],
      COUNTRY_LIST: [],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getCountryList();
  },
  methods: {
    // 获取国家
    getCountryList() {
      commonApi.getProvince().then(res => {
        if (!res.length) return;
        this.COUNTRY_LIST = res.map(item => {
          return {
            label: item.name,
            value: item.shortName
          };
        });
      });
    },
    // EXCEL导入
    onImport() {
      this.$refs.ExcelImport.show();
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(`${this.$t('toast.youAreDelTipText')} ${row.suburb}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        thirdApi.deletePostCode([row.id]).then(res => {
          if (!res.failed) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        });
      });
    },
    /** 新建 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$refs.DataForm.show(this.$lodash.clone(row));
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
